module.exports = __webpack_public_path__ + "static/media/SDM-new.6e964208.png";